import { render, staticRenderFns } from "./support_user_call_record_table.vue?vue&type=template&id=25cec63f&scoped=true&"
import script from "./support_user_call_record_table.vue?vue&type=script&lang=js&"
export * from "./support_user_call_record_table.vue?vue&type=script&lang=js&"
import style0 from "./support_user_call_record_table.vue?vue&type=style&index=0&id=25cec63f&prod&lang=css&"
import style1 from "./support_user_call_record_table.vue?vue&type=style&index=1&id=25cec63f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cec63f",
  null
  
)

export default component.exports